(ns practitest.frontend.components2.dashboard.charts.gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.charts.render-helpers :as rh]
            [practitest.frontend.components2.dashboard.transforms.gauge :as transforms]))

(def level-colors
  {:low    "var(--pt-color-error)"
   :medium "var(--pt-color-warning)"
   :high   "var(--pt-color-success)"})

(defn- color-encoding
  "Dot legend of the levels, labeled with their ranges."
  [legend]
  {:field  :level
   :type   :nominal
   :scale  {:domain (mapv (comp name :level) legend)
            :range  (mapv (comp level-colors :level) legend)}
   :labels (into {}
                 (map (fn [{:keys [level label range]}]
                        [(name level) (str label " " range)]))
                 legend)
   :legend {:symbol    :dot
            :columns   (count legend)
            :max-width 400
            :offset    25}})

(defn base-spec
  [{:keys [legend] :as datum}]
  {:mark       :gauge
   :min-radius 100
   :max-radius 120
   :padding    0
   :tooltip    true
   :data       [datum]
   :encode     (cond-> {:theta {:field :value :type :quantitative}}
                 (seq legend) (assoc :color (color-encoding legend)))})

(defmethod p/transform-data ::chart/gauge [chart]
  (transforms/transform chart))

(defmethod p/render! ::chart/gauge [{:chart/keys [data]} _ctx svg-el]
  (r/render-chart! svg-el (base-spec data)))

(defmethod p/svg-for-export ::chart/gauge [_chart svg-element]
  (let [clone (rh/clone-svg svg-element)]
    (rh/embed-styles! svg-element clone
                      [".arc-bg" ".arc-value" ".value-text" ".label-text"
                       ".legend-label"
                       ".badge-bg" ".badge-text" ".scale-label"]
                      {:keep-props #{"fill"}})
    (rh/pad-viewbox! clone 30)
    clone))
